import { z } from 'zod';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#benachrichtigung
    {
        "aktiv": true | false
    }

*/
export const schemaEuropaceBenachrichtigung = z.object({
    // If the Benachrichtigung is set to aktiv, the Kundenbetreuer receives a confirmation email.
    aktiv: z.optional(z.boolean()),
});

export type SchemaEuropaceBenachrichtigung = z.infer<typeof schemaEuropaceBenachrichtigung>;
